import * as React from 'react';

import { isNil } from 'lodash';

import { __t, applyTranslations } from 'utils/language';
import { abbrNum } from 'utils/helper/common';

import type { NetworkGraphNodeRaw, NetworkGraphTierLabels } from 'types';

applyTranslations(require('locales/common/collabary-common.i18n.json'));
applyTranslations(require('../network-graph.i18n.json'));

const COMMON_MSG_KEY = 'collabary_common';
const MSG_KEY = 'network_graph';

const getTooltipFollowers = (followers: number | undefined | null, tier: NetworkGraphTierLabels): React.ReactNode => {
  if (isNil(followers)) {
    return '';
  }

  return (
    <div>
      {abbrNum(followers)} {__t(`${MSG_KEY}.labels.followers`)} ({__t(`${COMMON_MSG_KEY}.influencer_tiers.labels.${tier}`)})
    </div>
  );
};

const getTooltipProfileLink = (profileId: number | undefined | null, profileName: string): React.ReactNode => {
  if (isNil(profileId) && isNil(profileName)) {
    return '';
  }

  const isProfile = !isNil(profileId);
  const profileLink = isProfile
    ? `/content-creator/profiles/${String(profileId)}`
    : `https://instagram.com/${profileName}`;

  return (
    <div>
      <a
        href={profileLink}
        className="network-graph__tooltip-link"
        rel="noopener noreferrer"
        target="_blank"
      >
        {__t(`${MSG_KEY}.labels.view_${isProfile ? 'profile' : 'instagram'}`)}
      </a>
    </div>
  );
};

export const getTooltip = (node: NetworkGraphNodeRaw, tier: NetworkGraphTierLabels): React.ReactNode => (
  <div className="network-graph__tooltip">
    <div className="network-graph__tooltip-header">
      <div className="network-graph__tooltip-influencer">
        <div className="network-graph__tooltip-influencer-name">
          {node.profileName}
        </div>
        {getTooltipFollowers(node.followers, tier)}
        {getTooltipProfileLink(node.profileId, node.profileName)}
      </div>
    </div>
  </div>
);
